export const CLAIMS_PER_PAGE = 7;
